import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import type { OtPurposesByCategoryAndUser } from "@jti/fe-common";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { CasPurposesApi } from "../../../services";
import { getUser } from "../../../utils/User";

export const useUserConsents = (
  context: "all" = "all",
  enabled = true
): UseQueryResult<OtPurposesByCategoryAndUser[]> => {
  const { uuid } = getUser();

  return useQuery({
    queryKey: [QUERY_KEYS.userConsents, uuid, context],
    queryFn: () => CasPurposesApi.init().getPurposesForUserByCategory(context),
    staleTime: 5000,
    retry: false,
    enabled,
  });
};
